var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCegidCorners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F5FA7164-FD6E-44BD-8736-97A003CC65A8@0.50x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09.2----Profil-|-Vue-employ\\xE9-|-Dialog---Annuaire-chgt-compte",
    transform: "translate(-547.000000, -886.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(402.000000, 838.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logotypes",
    transform: "translate(145.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Images-/-1:1-/-Corners"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Surface",
    fill: "#0046FE",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7659211,42 C28.1070354,42 24,37.8442652 24,32.1188741 C24,26.2554983 28.3080927,22 34.242863,22 C36.2905246,22 37.8410736,22.3634244 39.9199675,23.3364428 L38.3206181,27.3004243 C36.9581131,26.7005474 35.9703945,26.4764033 34.7198048,26.4764033 C31.5803172,26.4764033 29.0999593,28.2961163 29.0999593,32.0398406 C29.0999593,35.7835649 31.5100447,37.6026301 34.7998373,37.6026301 C36.0614884,37.6026301 37.0563644,37.3201827 38.3089061,36.6004599 L40,40.1070839 C37.9861732,41.4156707 36.0588857,42 33.7659211,42",
    id: "Fill-11",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCegidCorners);
export default __webpack_public_path__ + "static/media/Cegid_Corners.d92310d66d4a8a8119c3868a6f0a8d0f.svg";
export { ForwardRef as ReactComponent };